export default "__VITE_ASSET__ee881959__"